var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

var Footer = function () {

	this.banner;
	this.$close;
	// Get script text/template element
	this.template = document.getElementById( 'weeding-list-banner' );
	// If template exists set the inner HTML
	if ( this.template ) {
		this.templateHtml = this.template.innerHTML;
	}

	this.days = 0;
	this.date = '';
};

Footer.prototype.init = function () {

	var self = this;

	// Maybe do something if template tag has inner content and the banner cookie is not set
	if ( self.templateHtml && "yes" !== document.cookie.replace(/(?:(?:^|.*;\s*)big_close_flash\s*\=\s*([^;]*).*$)|^.*$/, "$1") ) {

		$( 'body' ).addClass( 'has-sitewide-flash' );

		// Move the template content outside it's parent container
		self.template.outerHTML = self.templateHtml;

		// Map newly added objects
		self.$close = $( document.querySelector( '#sitewide-flash a.close' ) );
		self.$banner = $( document.querySelector( '#sitewide-flash' ) );

		// On close click
		self.$close.click( function ( e ) {

			e.preventDefault();

			self.days = 0.5;
			self.date = new Date();

			self.$banner.addClass( 'close' );

			$( 'body' ).removeClass( 'has-sitewide-flash' );

			self.date.setTime( self.date.getTime() + (
				self.days * 24 * 60 * 60 * 1000
			) );

			document.cookie = "big_close_flash = yes; expires = " + self.date.toGMTString();
		} );
	}
};

module.exports = new Footer();
